import { useRef } from 'react'
import type { LifeSpace } from '@/src/renderer/lib/db/models'
import type { SidebarCounts } from './dataSource'

const SPACES: readonly LifeSpace[] = ['personal', 'work', 'home']

/** `0` und `false`, solange die Zahlen zum allerersten Mal laden. */
export const EMPTY_SIDEBAR_COUNTS: SidebarCounts = {
  personal: { upcomingCount: 0, quickNotesHasEntries: false },
  work: { upcomingCount: 0, quickNotesHasEntries: false },
  home: { upcomingCount: 0, quickNotesHasEntries: false },
}

const sameCounts = (a: SidebarCounts, b: SidebarCounts) => SPACES.every(space =>
  a[space].upcomingCount === b[space].upcomingCount && a[space].quickNotesHasEntries === b[space].quickNotesHasEntries)

/**
 * Hält das Ergebnis, solange sich keine Zahl ändert: Die Abfrage läuft bei jedem Schreibvorgang neu
 * (auch jeder Zeile eines Pulls) und liefert jedes Mal ein frisches Objekt — ohne das renderte der
 * Kontext der Seitenleiste jedes Mal mit.
 */
export function useStableSidebarCounts(counts: SidebarCounts | undefined): SidebarCounts {
  const ref = useRef<SidebarCounts>(EMPTY_SIDEBAR_COUNTS)
  if (counts && !sameCounts(ref.current, counts)) ref.current = counts
  return ref.current
}
